import { render, staticRenderFns } from "./ExpirationsTableClub.vue?vue&type=template&id=72f28d72&"
import script from "./ExpirationsTableClub.vue?vue&type=script&lang=js&"
export * from "./ExpirationsTableClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports